import { SignIn } from "@clerk/clerk-react";
import instructorImage from "@/assets/instructor-sign-in.jpg";
import { Text } from "@mantine/core";
import { LegalConsentNotice } from "@/components/legal-consent-notice";
import { Page } from "@/components/page";
import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "./-components/auth-layout";

export const Route = createFileRoute("/_authenticate/sign-in/$")({
  component: SignInRouteComponent,
});

function SignInRouteComponent() {
  return (
    <Page title="Sign in">
      <AuthLayout image={instructorImage}>
        <Text mb="1rem" ml="0.5rem" c="pink.1" size="sm" maw="min(90vw, 400px)">
          By signing in, you consent that you are either over 18 or of legal age
          in your jurisdiction, whichever is greater. 
        </Text>
        <SignIn path="/sign-in" signUpUrl="/sign-up" />
        <LegalConsentNotice />
      </AuthLayout>
    </Page>
  );
}
